var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 27,
    viewBox: "0 0 55 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9154 7.54102L21.8954 19.526L28.9154 7.54102Z",
    fill: "url(#paint0_linear_210_33450)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7803 0.00999998C12.7803 0.00999998 12.7654 0.00999998 12.7554 0.00999998C12.4654 0.0299999 12.1804 0.0549999 11.8904 0.0899998C11.8704 0.0899998 11.8554 0.0949998 11.8354 0.0999998C8.17036 0.579999 4.73037 2.54499 2.47538 5.73499C2.46538 5.75499 2.45038 5.76999 2.43538 5.78999C2.42038 5.80499 2.41038 5.82499 2.40038 5.84499C2.39038 5.85999 2.37538 5.87999 2.36538 5.89499C2.24538 6.06499 2.13037 6.24499 2.01537 6.42499C1.96537 6.50498 1.92037 6.57999 1.87037 6.65999C1.85537 6.68498 1.84038 6.70498 1.83038 6.72998C-1.89961 13.135 0.25038 21.31 6.65037 25.0299C8.93036 26.3549 11.4404 26.9299 13.9003 26.8449L13.8903 26.8549H18.5153H17.5903V26.8449C17.5903 26.8449 17.5903 26.8449 17.5953 26.8449L21.2403 20.625L21.6603 19.91L21.8953 19.505C21.8703 19.54 21.8453 19.57 21.8203 19.605C21.8053 19.62 21.7903 19.64 21.7753 19.655C20.0303 21.805 17.4553 23.1349 14.6953 23.3099H14.6753H14.6253H14.6053L14.4703 23.3149C14.3453 23.3199 14.2103 23.3249 14.0503 23.3249H13.9203H13.8753L12.5954 23.2199C7.73036 22.5099 4.02037 18.28 4.12037 13.295C4.22537 8.08498 8.42036 3.85999 13.6653 3.67499C13.8403 3.66999 14.0103 3.66499 14.1803 3.66999L31.3053 4.01999L31.1003 4.35999C33.3653 1.92 36.5203 0.309999 40.0503 0.0449999C40.0703 0.0449999 40.0953 0.0449999 40.1153 0.0449999C40.1353 0.0449999 40.1603 0.0449999 40.1803 0.0449999C40.2003 0.0449999 40.2203 0.0449999 40.2403 0.0449999C40.4503 0.0299999 40.6653 0.02 40.8753 0.02C40.9703 0.02 41.0603 0.02 41.1553 0.02C41.3203 0.00999998 12.7703 0 12.7703 0L12.7803 0.00999998Z",
    fill: "url(#paint1_linear_210_33450)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2552 0.0360952C41.2252 0.0360952 41.2002 0.0360952 41.1702 0.0360952C41.0752 0.0360952 40.9852 0.0360952 40.8902 0.0360952C40.6752 0.0360952 40.4652 0.0460952 40.2552 0.0610952C40.2352 0.0610952 40.2152 0.0610952 40.1952 0.0610952C40.1752 0.0610952 40.1502 0.0610952 40.1302 0.0610952C40.1102 0.0610952 40.0852 0.0610952 40.0652 0.0610952C36.1452 0.351095 32.7302 2.13109 30.4453 5.03608C30.4353 5.05108 30.3752 5.23108 30.3652 5.24608C30.1903 5.47608 30.0153 5.70608 29.8553 5.94608C29.8503 5.95108 29.8453 5.96108 29.8403 5.96608L28.9253 7.53108L21.6703 19.921L21.2503 20.636L17.6053 26.856C17.6053 26.856 17.6053 26.856 17.6003 26.856L41.0102 27.001C41.2702 27.001 41.5302 27.001 41.7852 26.981C48.9252 26.626 54.6202 20.786 54.6652 13.5911C54.7102 6.17608 48.7202 0.116095 41.2652 0.0210953L41.2552 0.0360952ZM41.1402 23.346C40.9652 23.351 40.7952 23.356 40.6252 23.351L23.5003 23.001L31.8153 9.26107L32.6752 7.83608C32.7752 7.69608 32.8802 7.55608 32.9902 7.41608C33.0052 7.40108 33.0202 7.38108 33.0352 7.36608C34.7802 5.21608 37.3552 3.88609 40.1152 3.71109H40.1352H40.1852H40.2052L40.3402 3.70609C40.4652 3.70109 40.6002 3.69609 40.7602 3.69609H40.8902H40.9352L42.2152 3.80109C47.0802 4.51108 50.7902 8.74107 50.6902 13.7261C50.5852 18.9361 46.3902 23.161 41.1452 23.346H41.1402Z",
    fill: "url(#paint2_linear_210_33450)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2303 3.79377L40.9503 3.68877H40.9053H40.7753C40.6153 3.68877 40.4803 3.68877 40.3553 3.69877H40.2203L40.2003 3.70377H40.1503H40.1303C37.3703 3.87877 34.7953 5.20876 33.0503 7.35376C33.0353 7.36876 33.0203 7.38876 33.0053 7.40376C32.8953 7.54376 32.7903 7.68376 32.6903 7.82376L31.8303 9.24875L23.5103 22.9837L40.6353 23.3437C40.8053 23.3437 40.9753 23.3437 41.1503 23.3387C46.3953 23.1537 50.5902 18.9337 50.7002 13.7237C50.8052 8.73375 47.0953 4.50376 42.2353 3.79377H42.2303ZM40.7603 21.5587C40.6603 21.5587 40.5603 21.5637 40.4653 21.5637H40.3503L26.6453 21.2737L33.2003 10.4588L34.0203 9.10375L34.0353 9.08375C34.0953 9.00375 34.1553 8.92375 34.2203 8.83875L34.2653 8.78875C35.6353 7.09876 37.6653 6.03376 39.8353 5.86876H39.9403L39.9553 5.86376L40.1553 5.85376C40.2453 5.84876 40.3453 5.84876 40.4553 5.84376H40.5403L41.6953 5.93876H41.7153C45.6203 6.55376 48.5002 9.96375 48.4202 13.8737C48.3353 18.0387 44.9703 21.4187 40.7703 21.5637L40.7603 21.5587Z",
    fill: "url(#paint3_linear_210_33450)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1904 3.68877C14.0204 3.68877 13.8504 3.68877 13.6754 3.69377C8.43039 3.87877 4.23539 8.10376 4.1304 13.3137C4.0304 18.3037 7.73538 22.5337 12.6054 23.2387L13.8854 23.3437H13.9304H14.0604C14.2204 23.3437 14.3554 23.3437 14.4804 23.3337H14.6154L14.6354 23.3287H14.6854H14.7054C17.4654 23.1537 20.0404 21.8237 21.7854 19.6737C21.8004 19.6587 21.8154 19.6387 21.8304 19.6237C21.9404 19.4837 22.0454 19.3437 22.1454 19.2037L23.0053 17.7787L31.3203 4.03877L14.1954 3.68877H14.1904ZM21.6354 16.5737L20.8154 17.9287L20.8004 17.9487C20.7404 18.0287 20.6804 18.1087 20.6154 18.1937L20.5704 18.2437C19.2004 19.9337 17.1704 20.9987 15.0054 21.1687H14.9054L14.8904 21.1737L14.6904 21.1837C14.6004 21.1887 14.5004 21.1937 14.3904 21.1937H14.3054L13.1504 21.0987H13.1304C9.22538 20.4887 6.34539 17.0787 6.42539 13.1687C6.51039 9.00375 9.87038 5.62376 14.0704 5.47376C14.1754 5.47376 14.2754 5.46876 14.3754 5.46876H14.4854L28.1903 5.74876L21.6404 16.5687L21.6354 16.5737Z",
    fill: "url(#paint4_linear_210_33450)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_210_33450",
    x1: 21.8954,
    y1: 13.536,
    x2: 28.9154,
    y2: 13.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#07147E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#213AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#3152C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375BCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_210_33450",
    x1: 0.000381473,
    y1: 13.44,
    x2: 41.1653,
    y2: 13.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1239BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1131A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_210_33450",
    x1: 17.5903,
    y1: 13.5211,
    x2: 54.6552,
    y2: 13.5211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1239BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1131A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_210_33450",
    x1: 23.5103,
    y1: 13.5187,
    x2: 50.7002,
    y2: 13.5187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#EE4226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#EE4526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#EF4E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F15E28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F4752A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F7932C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FBAE2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F9A52E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F78E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F26929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE4226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_210_33450",
    x1: 4.1254,
    y1: 13.5187,
    x2: 31.3103,
    y2: 13.5187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#EE4226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#EE4526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#EF4E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F15E28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F4752A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F7932C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FBAE2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F9A52E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F78E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F26929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE4226"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.badf25f0d7d07cbedc4f5e699049f3dd.svg";
export { ForwardRef as ReactComponent };